import { render, staticRenderFns } from "./LiquidationEdit.vue?vue&type=template&id=b5579ca4&scoped=true"
import script from "./LiquidationEdit.vue?vue&type=script&lang=js"
export * from "./LiquidationEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5579ca4",
  null
  
)

export default component.exports